import React from 'react'
import { Box, Paper } from '@mui/material'
import PrivilegeSearch from './PrivilegeSearch'
import PrivilegesTree from './PrivilegesTree'
import { getAccent, hexToRgba } from './constants'

const PrivilegesPanel = ({
  groups = [],
  open = {},
  privilegeSearch = '',
  onSearchChange,
  onPrivilegeChange,
  onToggleGroup,
  classes,
  translate,
  themecolors = {},
}) => {
  const accent = getAccent(themecolors)
  const muted = themecolors.themeDarkColor || '#667085'

  return (
    <div className="individual-view">
      <PrivilegeSearch
        value={privilegeSearch}
        onChange={onSearchChange}
        translate={translate}
        themecolors={themecolors}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1.25,
          pb: 2,
        }}
      >
        {groups.length ? (
          groups.map(group => (
            <PrivilegesTree
              key={group.id}
              data={group}
              handleChange={onPrivilegeChange}
              handleClick={onToggleGroup}
              classes={classes}
              translate={translate}
              open={open}
              themecolors={themecolors}
            />
          ))
        ) : (
          <Paper
            elevation={0}
            sx={{
              p: 3,
              textAlign: 'center',
              border: '1px dashed',
              borderColor: hexToRgba(accent, 0.2),
              borderRadius: '10px',
              color: muted,
            }}
          >
            {translate('noRecordFound') || 'No privileges found'}
          </Paper>
        )}
      </Box>
    </div>
  )
}

export default PrivilegesPanel
